var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-warnings"},_vm._l((_vm.images),function(image,index){return _c('div',{key:index,staticClass:"footer-warnings__item"},[_c('img',{attrs:{"src":_vm.getImagePath(image),"alt":""}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }